import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Check } from "../Icons";
import { Row } from "antd";
import "./StepByStep.scss";

const VerticalStepByStep = (props: any & RouteComponentProps<any>) => {
  let isResolved = true;

  return (
    <div style={{ textAlign: "left" }}>
      <Row>
        <h5
          style={{
            color: "grey",
            textTransform: "uppercase",
            textAlign: "right",
            paddingBottom: "25px",
            borderBottom: "solid lightgrey thin",
            margin: "35px 30px 35px 20px"
          }}
        >
          Etapas do Processo
        </h5>
        <ul style={{ listStyle: "none", paddingLeft: "0", marginRight: "20px" }}>
          {props.steps.map((step, idx) => {
            isResolved = step.active ? false : isResolved;

            return (
              <li
                key={idx}
                className={`${isResolved === true ? "is-skipped" : step.active ? " is-active" : "is-pending"}`}
                style={{ margin: "35px auto", padding: "30px auto 50px 50px" }}
              >
                <span style={{ fontWeight: "bold", fontSize: "25px", verticalAlign: "middle" }}>{idx + 1}</span>
                <span style={{ textTransform: "uppercase", margin: "auto 20px" }}>{step.title}</span>
                <span>{isResolved === true ? <Check styles={{ width: "20px", float: "right", marginTop: "10px", marginRight: "0" }} /> : ""}</span>
              </li>
            );
          })}
        </ul>
      </Row>
    </div>
  );
};

export default VerticalStepByStep;



// WEBPACK FOOTER //
// ./src/components/common/StepByStep/VerticalStepByStep.tsx